import React from "react";
import { Check } from "lucide-react";
import { AI_TOOLS, AI_3D_IMAGE, BLUEPRINT_IMAGE } from "../mock";
import ChatWidget from "./ChatWidget";

const images = { estimator: BLUEPRINT_IMAGE, assistant: null, vision: AI_3D_IMAGE };

const AIFeatures = () => {
  return (
    <section id="ai-tools" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-semibold uppercase tracking-wider text-[#DC2626]">
            AI, end to end
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-700 tracking-tight text-[#0A2540]">
            Every part of the estimate is AI-powered
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            From the first ballpark to the final 3D render — intelligence at each step.
          </p>
        </div>

        <div className="mt-16 space-y-20">
          {AI_TOOLS.map((t, i) => {
            const flip = i % 2 === 1;
            const img = images[t.id];
            return (
              <div
                key={t.id}
                className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                  flip ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div>
                  <span className="inline-block rounded-full bg-blue-50 text-[#1D4ED8] text-xs font-semibold px-3 py-1">
                    {t.tag}
                  </span>
                  <h3 className="font-display mt-4 text-3xl font-700 text-[#0A2540] leading-tight">
                    {t.title}
                  </h3>
                  <p className="mt-4 text-lg text-slate-600 leading-relaxed">{t.body}</p>
                  <ul className="mt-6 space-y-3">
                    {t.bullets.map((b) => (
                      <li key={b} className="flex items-center gap-3 text-slate-700">
                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#DC2626]/10">
                          <Check className="h-3 w-3 text-[#DC2626]" />
                        </span>
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="relative">
                  {img ? (
                    <div className="rounded-2xl overflow-hidden shadow-xl ring-1 ring-slate-200">
                      <img src={img} alt={t.title} className="w-full h-[340px] object-cover" />
                    </div>
                  ) : (
                    <ChatWidget />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AIFeatures;
